import { infoKitCard } from '../../../core/models/DigitalKit';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['./info-card.component.css'],
    standalone: false
})
export class InfoCardComponent implements OnInit {
@Input() infoCard: infoKitCard;
  constructor() { }

  ngOnInit(): void {
  }

}
